module.exports = __webpack_public_path__ + "static/media/reshetka_boya.b9170f48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sales/reshetka_boya.jpg
// module id = 237
// module chunks = 0